// ********************** Dynamic Product Listing **********************
// -- Product Data
export var dynamicNestedData = GetData();

// Processing Variables Initialization

// Update data
export function UpdateCartItem(id, operation){
  var tempData = dynamicNestedData;
  var item = tempData.find(item => item.ID == id)
  // alert(item.Label + " | " + item.CartCount);

  //
  if(operation == "ADD"){
    item.CartCount += 1;
    item.IsAdded = 1;
  }
  else if(operation = "REMOVE"){
    item.CartCount -= 1;
    if(item.CartCount == 0)
      item.IsAdded = 0;
  }

  // alert(item.Label + " | " + item.CartCount);

  // --
  dynamicNestedData = tempData;
}

// -- Generate Data
function GetData(){
  var kwenchData = [
                  {ID: 'A', Label: 'Grapefruit Bliss' , Size: '8Oz', IsAdded: 1, CartCount: 2, Price: '8.50' , ImgSrc: '../grapefruit_bliss.5689cfc4.jpg'}, 
                  {ID: 'B', Label: 'Orange Slices'    , Size: '16Oz', IsAdded: 0, CartCount: 0, Price: '10.50', ImgSrc: '../orange_slices.2e1f8bde.jpg '}, 
                  {ID: 'C', Label: 'Incredible Gulp'  , Size: '8Oz', IsAdded: 1, CartCount: 1, Price: '9.50' , ImgSrc: '../greenie_vineyard.b426e448.jpg'},
                  {ID: 'D', Label: 'Beets Digest'     , Size: '8Oz', IsAdded: 1, CartCount: 5, Price: '9.50' , ImgSrc: '../beets_digest.bb7b7c40.jpg '},
                  {ID: 'E', Label: 'Signature Drinks' , Size: '16Oz', IsAdded: 0, CartCount: 0, Price: '9.50' , ImgSrc: '../signature_drinks.54999d25.jpg'}
                ];
  // var kwenchData = [
  //                 {ID: 'A', Label: 'Grapefruit Bliss' , Size: '16Oz', IsAdded: 1, CartCount: 2, Price: '8.50' , ImgSrc: '../Images/grapefruit_bliss.jpg'}, 
  //                 {ID: 'B', Label: 'Orange Slices'    , Size: '16Oz', IsAdded: 0, CartCount: 0, Price: '10.50', ImgSrc: '../Images/orange_slices.jpg '}, 
  //                 {ID: 'C', Label: 'Incredible Gulp'  , Size: '8Oz', IsAdded: 1, CartCount: 1, Price: '9.50' , ImgSrc: '../Images/greenie_vineyard.jpg'},
  //                 {ID: 'D', Label: 'Beets Digest'     , Size: '8Oz', IsAdded: 1, CartCount: 4, Price: '9.50' , ImgSrc: '../Images/beets_digest.jpg '},
  //                 {ID: 'E', Label: 'Signature Drinks' , Size: '16Oz', IsAdded: 0, CartCount: 0, Price: '9.50' , ImgSrc: '../Images/signature_drinks.jpg'}
  //               ];

  // --
  return kwenchData;
}